import React from 'react';
import { ArrowRight, Shield, CheckCircle, Sparkles } from 'lucide-react';

const safetyTopics = [
  { num: '1', text: 'Ошибки, которые я совершил, начиная бизнес на Amazon' },
  { num: '2', text: 'Топ-5 причин, почему у большинства не получается Amazon-бизнес' },
  { num: '3', text: 'Нужен ли английский язык для работы с Amazon' },
  { num: '4', text: 'Сколько реально можно заработать на Amazon (примеры цифр)' },
  { num: '5', text: 'Налоги и компания: где, как и почему' },
  { num: '6', text: 'Ошибки при регистрации аккаунта, из-за которых теряют доступ' },
];

const SafetyPage = () => {
  const handleCTA = () => {
    // Redirect to Telegram bot or next step
    window.open('https://t.me/vadjik', '_blank');
  };

  return (
    <div className="min-h-screen bg-[#050506] flex items-center justify-center px-4 py-12">
      {/* Background Effects */}
      <div className="fixed inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-[600px] h-[600px] bg-amber-500/[0.03] rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-violet-500/[0.03] rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-2xl w-full">
        {/* Card Container */}
        <div className="relative">
          {/* Glow Effect */}
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-500/20 via-orange-500/30 to-amber-500/20 rounded-[2rem] blur-xl" />
          
          {/* Main Card */}
          <div className="relative bg-gradient-to-b from-zinc-900/95 to-zinc-950/95 backdrop-blur-xl rounded-[2rem] p-8 sm:p-10 lg:p-12 border border-amber-500/20">
            
            {/* Badge */}
            <div className="flex justify-center mb-8">
              <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-amber-500/10 border border-amber-500/30">
                <Shield className="w-5 h-5 text-amber-400" />
                <span className="text-amber-300 font-bold text-sm uppercase tracking-wider">Бесплатные материалы</span>
              </div>
            </div>

            {/* Title */}
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center mb-6 leading-tight">
              <span className="bg-gradient-to-b from-white via-white to-zinc-400 bg-clip-text text-transparent">6 критических ошибок</span>
              <br />
              <span className="text-xl sm:text-2xl lg:text-3xl text-zinc-400 font-medium">в бизнесе на Amazon, о которых не говорят</span>
            </h1>

            {/* Subtitle */}
            <p className="text-center text-zinc-400 text-base sm:text-lg mb-10 max-w-lg mx-auto leading-relaxed">
              Я собрал чек-листы по ключевым ошибкам новичков.
              <br />
              <span className="text-amber-400 font-semibold">В следующем шаге ты сможешь выбрать 2 темы</span>, которые получишь бесплатно.
            </p>

            {/* Topics List */}
            <div className="space-y-4 mb-10">
              {safetyTopics.map((topic, i) => (
                <div 
                  key={i}
                  className="flex items-start gap-4 p-4 rounded-xl bg-zinc-800/50 border border-zinc-700/50 hover:border-amber-500/30 hover:bg-zinc-800/70 transition-all duration-300"
                >
                  <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-amber-500/20">
                    <span className="text-black font-black text-lg">{topic.num}</span>
                  </div>
                  <p className="text-zinc-200 text-base sm:text-lg pt-1.5 leading-relaxed">{topic.text}</p>
                </div>
              ))}
            </div>

            {/* Mechanics Explanation */}
            <div className="text-center p-5 rounded-2xl bg-zinc-800/30 border border-zinc-700/30 mb-8">
              <div className="flex items-center justify-center gap-2 mb-2">
                <Sparkles className="w-5 h-5 text-amber-400" />
                <span className="text-amber-400 font-bold">Как это работает</span>
              </div>
              <p className="text-zinc-400 text-sm sm:text-base">
                На следующем шаге ты выберешь <span className="text-white font-semibold">2 темы</span>,
                <br className="hidden sm:block" /> которые получишь в формате чек-листов и коротких разборов.
              </p>
            </div>

            {/* CTA Button */}
            <button
              onClick={handleCTA}
              className="group w-full relative py-5 px-8 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-500 bg-[length:200%_100%] animate-gradient text-black font-black text-lg sm:text-xl rounded-2xl shadow-2xl shadow-amber-500/30 hover:shadow-amber-500/50 hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3"
            >
              <span>Перейти к выбору тем</span>
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" />
              
              {/* Shine Effect */}
              <div className="absolute inset-0 rounded-2xl overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
              </div>
            </button>

            {/* Small note */}
            <p className="text-center text-zinc-600 text-xs mt-6">
              Без спама. Только полезные материалы.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SafetyPage;
